<template>
  <div id="login">
    <section class="bannerprincipal">
      <SiteNav v-if="showNav"></SiteNav>
      <div
        v-if="!showNav"
        class="col-12 text-center"
        data-aos="fade-down"
        data-aos-delay="100"
      ></div>

      <div class="container d-block d-lg-none">
        <div class="row">
          <div class="col-12 py-3">&nbsp;</div>
          <div class="col-12 py-3">&nbsp;</div>
        </div>
      </div>

      <div class="container-fluid py-5">
        <div class="row py-5">
          <div class="col-md-7">
            <img
              class="img-fluid"
              src="../assets/imgs/copaprosa2025/copa-prosa-golfistas.png"
              alt="Copa Prosa"
            />
          </div>
          <div
            class="col-md-5 pt-0 pt-lg-4 pt-5 my-0 my-lg-5"
            data-aos="fade-up"
            data-aos-delay="500"
            v-if="signupForm.codigo == '' && reenvioForm.codigo == ''"
          >
            <div class="row">
              <div class="col-8 offset-2 text-center d-none d-lg-block">
                <img
                  class="img-fluid"
                  src="../assets/imgs/copaprosa2025/logo-home.png"
                  alt="Copa Prosa"
                />
              </div>
            </div>

            <form
              @submit="presignup($event)"
              class="negro bgtrans mt-0 mt-lg-3 py-4"
            >
              <div class="col-12 text-left pb-4">
                <!-- <p class="negro fR bold">¡Bienvenidos a Copa Prosa!</p> -->
                <!-- <p class="negro fR">Estimado Cliente y Socio de Negocio:</p> -->
                <!-- <p class="negro fR">
                  Sabemos que este Torneo de Golf es el más esperado en nuestro
                  ecosistema de medios de pago. Te esperamos con gusto y seguros
                  que será, una vez más, una experiencia para disfrutar la
                  convivencia y networking.
                </p> -->
                <p class="negro fR pt-0">
                  Para comenzar ingresa el <b>Código de Registro</b> que viene
                  en tu invitación:
                </p>
              </div>
              <div class="col-12">
                <div class="row pb-2">
                  <div class="col-lg-12 pb-0">
                    <!-- <div class="negro fG">Nombre</div> -->
                    <input
                      v-model.trim="preForm.codigo"
                      type="text"
                      placeholder="Clave de registro*"
                      required
                    />
                  </div>
                  <div class="col-lg-12 pb-0">
                    <!-- <div class="negro fG">Nombre</div> -->
                    <input
                      v-model.trim="preForm.apellido_paterno"
                      type="text"
                      placeholder="Apellido Paterno*"
                      @input="
                        updateInputPreform(
                          'apellido_paterno',
                          $event.target.value
                        )
                      "
                      required
                    />
                  </div>
                  <div class="col-lg-12 pb-0">
                    <!-- <div class="negro fG">Nombre</div> -->
                    <input
                      v-model.trim="preForm.email"
                      type="email"
                      placeholder="Correo Electrónico*"
                      required
                    />
                  </div>
                </div>

                <div class="row pb-0">
                  <div class="col-12 text-center">
                    <button
                      type="submit"
                      class="pointer d-flex align-items-center justify-content-center btnaction fG ml-auto mr-auto"
                    >
                      COMENZAR REGISTRO
                    </button>
                  </div>
                </div>
              </div>
              <!-- <div class="extras text-center">
                    <a @click="toggleForm()" class="pointer"
                      >Regresar al Login</a
                    >
                  </div> -->
            </form>
          </div>

          <div
            class="col-md-5 pt-5 mt-5 bg-white"
            data-aos="fade-left"
            data-aos-delay="500"
            v-if="reenvioForm.codigo != ''"
          >
            <div class="row pb-5" v-if="asistencia === 1">
              <div
                class="col-md-12 offset-md-0 col-10 offset-1 text-left pb-4 text-center"
              >
                <p class="pb-4 fG pt-3 negro">
                  <span class="bold" v-html="nombre"></span>, tu registro se
                  realizó exitosamente. <br />¡Nos vemos pronto en
                  <b>Copa Prosa</b>!
                </p>
                <button
                  @click="reenvio()"
                  class="pointer d-flex align-items-center justify-content-center btnaction fG ml-auto mr-auto"
                >
                  REENVIAR CÓDIGO DE ACCESO
                </button>
              </div>
            </div>
            <div class="row pb-5" v-else>
              <div
                class="col-md-12 offset-md-0 col-10 offset-1 text-left pb-4 text-center"
              >
                <p class="pb-4 fG pt-3 negro">
                  <span class="bold" v-html="nombre"></span>, hemos registrado
                  tu ausencia al evento. Cualquier duda contacta a tu
                  <b>ejecutivo comercial</b>.
                </p>
              </div>
            </div>
          </div>
          <div
            class="col-md-5 pt-5 mt-5 bgtrans"
            data-aos="fade-left"
            data-aos-delay="500"
            v-if="signupForm.codigo != '' && reenvioForm.codigo == ''"
          >
            <form @submit="signup($event)" class="pb-5 r15">
              <div class="col-12 text-left pb-4 fXG">
                <span class="">REGISTRO</span>
              </div>
              <div class="col-12">
                <div class="row pb-4">
                  <div class="col-lg-12 pb-0">
                    <!-- <div class="negro fG">Nombre</div> -->
                    <input
                      v-model.trim="signupForm.codigo"
                      type="text"
                      placeholder="Clave de registro*"
                      required
                      readonly
                    />
                  </div>
                  <div class="col-lg-12 pb-0">
                    <!-- <div class="negro fG">Nombre</div> -->
                    <input
                      v-model.trim="signupForm.nombre_1"
                      type="text"
                      placeholder="NOMBRE*"
                      @input="updateInput('nombre_1', $event.target.value)"
                      required
                      readonly
                    />
                  </div>
                  <div class="col-lg-12 pb-0">
                    <!-- <div class="negro fG">Nombre</div> -->
                    <input
                      v-model.trim="signupForm.nombre_2"
                      type="text"
                      placeholder="SEGUNDO NOMBRE"
                      @input="updateInput('nombre_2', $event.target.value)"
                    />
                  </div>
                  <div class="col-lg-12 pb-0">
                    <!-- <div class="negro fG">Apellido</div> -->
                    <input
                      v-model.trim="signupForm.apellido_paterno"
                      type="text"
                      placeholder="APELLIDO PATERNO"
                      @input="
                        updateInput('apellido_paterno', $event.target.value)
                      "
                      readonly
                    />
                  </div>
                  <div class="col-lg-12 pb-0">
                    <!-- <div class="negro fG">Apellido</div> -->
                    <input
                      v-model.trim="signupForm.apellido_materno"
                      type="text"
                      placeholder="APELLIDO MATERNO"
                      @input="
                        updateInput('apellido_materno', $event.target.value)
                      "
                    />
                  </div>
                  <div class="col-lg-12 pb-0">
                    <!-- <div class="negro fG">Apellido</div> -->
                    <input
                      v-model.trim="signupForm.empresa"
                      type="text"
                      placeholder="EMPRESA*"
                      @input="updateInput('empresa', $event.target.value)"
                      required
                    />
                  </div>
                  <div class="col-lg-12 pb-0">
                    <!-- <div class="negro fG">Apellido</div> -->
                    <input
                      v-model.trim="signupForm.puesto"
                      type="text"
                      placeholder="PUESTO*"
                      @input="updateInput('puesto', $event.target.value)"
                      required
                    />
                  </div>
                  <div class="col-lg-12 pb-0">
                    <!-- <div class="negro fG">Apellido</div> -->
                    <input
                      v-model.trim="signupForm.email_user"
                      type="email"
                      placeholder="CORREO ELECTRÓNICO*"
                      @input="
                        signupForm.email_user =
                          $event.target.value.toLowerCase()
                      "
                      required
                      readonly
                    />
                  </div>

                  <div class="col-lg-12 pb-0">
                    <!-- <div class="negro fG">Apellido</div> -->
                    <select v-model="signupForm.genero" required>
                      <option value="">GÉNERO*</option>

                      <option value="Masculino">MASCULINO</option>
                      <option value="Femenino">FEMENINO</option>
                    </select>
                  </div>

                  <div class="col-lg-12">
                    <div class="row">
                      <div class="col-lg-5 pb-0">
                        <select v-model="signupForm.codigo_pais" required>
                          <option value="">CÓDIGO PAÍS</option>

                          <option value="+52">MÉXICO +52</option>
                          <option value="+1">ESTADOS UNIDOS +1</option>
                          <option value="+1">CANADÁ +1</option>
                          <option value="+55">BRASIL +55</option>

                          <!-- <optgroup label="_____________">
                            <option value="+7">+7</option>
                            <option value="+20">+20</option>
                            <option value="+27">+27</option>
                            <option value="+30">+30</option>
                            <option value="+31">+31</option>
                            <option value="+32">+32</option>
                            <option value="+33">+33</option>
                            <option value="+34">+34</option>
                            <option value="+36">+36</option>
                            <option value="+39">+39</option>
                            <option value="+40">+40</option>
                            <option value="+41">+41</option>
                            <option value="+43">+43</option>
                            <option value="+44">+44</option>
                            <option value="+45">+45</option>
                            <option value="+46">+46</option>
                            <option value="+47">+47</option>
                            <option value="+48">+48</option>
                            <option value="+49">+49</option>
                            <option value="+51">+51</option>
                            <option value="+53">+53</option>
                            <option value="+54">+54</option>
                            <option value="+56">+56</option>
                            <option value="+57">+57</option>
                            <option value="+58">+58</option>
                            <option value="+60">+60</option>
                            <option value="+61">+61</option>
                            <option value="+62">+62</option>
                            <option value="+63">+63</option>
                            <option value="+64">+64</option>
                            <option value="+65">+65</option>
                            <option value="+66">+66</option>
                            <option value="+81">+81</option>
                            <option value="+82">+82</option>
                            <option value="+84">+84</option>
                            <option value="+86">+86</option>
                            <option value="+90">+90</option>
                            <option value="+91">+91</option>
                            <option value="+92">+92</option>
                            <option value="+93">+93</option>
                            <option value="+94">+94</option>
                            <option value="+95">+95</option>
                            <option value="+98">+98</option>
                            <option value="+211">+211</option>
                            <option value="+212">+212</option>
                            <option value="+213">+213</option>
                            <option value="+216">+216</option>
                            <option value="+218">+218</option>
                            <option value="+220">+220</option>
                            <option value="+221">+221</option>
                            <option value="+222">+222</option>
                            <option value="+223">+223</option>
                            <option value="+224">+224</option>
                            <option value="+225">+225</option>
                            <option value="+226">+226</option>
                            <option value="+227">+227</option>
                            <option value="+228">+228</option>
                            <option value="+229">+229</option>
                            <option value="+230">+230</option>
                            <option value="+231">+231</option>
                            <option value="+232">+232</option>
                            <option value="+233">+233</option>
                            <option value="+234">+234</option>
                            <option value="+235">+235</option>
                            <option value="+236">+236</option>
                            <option value="+237">+237</option>
                            <option value="+238">+238</option>
                            <option value="+239">+239</option>
                            <option value="+240">+240</option>
                            <option value="+241">+241</option>
                            <option value="+242">+242</option>
                            <option value="+243">+243</option>
                            <option value="+244">+244</option>
                            <option value="+245">+245</option>
                            <option value="+246">+246</option>
                            <option value="+248">+248</option>
                            <option value="+249">+249</option>
                            <option value="+250">+250</option>
                            <option value="+251">+251</option>
                            <option value="+252">+252</option>
                            <option value="+253">+253</option>
                            <option value="+254">+254</option>
                            <option value="+255">+255</option>
                            <option value="+256">+256</option>
                            <option value="+257">+257</option>
                            <option value="+258">+258</option>
                            <option value="+260">+260</option>
                            <option value="+261">+261</option>
                            <option value="+262">+262</option>
                            <option value="+263">+263</option>
                            <option value="+264">+264</option>
                            <option value="+265">+265</option>
                            <option value="+266">+266</option>
                            <option value="+267">+267</option>
                            <option value="+268">+268</option>
                            <option value="+269">+269</option>
                            <option value="+290">+290</option>
                            <option value="+291">+291</option>
                            <option value="+297">+297</option>
                            <option value="+298">+298</option>
                            <option value="+299">+299</option>
                            <option value="+350">+350</option>
                            <option value="+351">+351</option>
                            <option value="+352">+352</option>
                            <option value="+353">+353</option>
                            <option value="+354">+354</option>
                            <option value="+355">+355</option>
                            <option value="+356">+356</option>
                            <option value="+357">+357</option>
                            <option value="+358">+358</option>
                            <option value="+359">+359</option>
                            <option value="+370">+370</option>
                            <option value="+371">+371</option>
                            <option value="+372">+372</option>
                            <option value="+373">+373</option>
                            <option value="+374">+374</option>
                            <option value="+375">+375</option>
                            <option value="+376">+376</option>
                            <option value="+377">+377</option>
                            <option value="+378">+378</option>
                            <option value="+380">+380</option>
                            <option value="+381">+381</option>
                            <option value="+382">+382</option>
                            <option value="+385">+385</option>
                            <option value="+386">+386</option>
                            <option value="+387">+387</option>
                            <option value="+389">+389</option>
                            <option value="+420">+420</option>
                            <option value="+421">+421</option>
                            <option value="+423">+423</option>
                            <option value="+500">+500</option>
                            <option value="+501">+501</option>
                            <option value="+502">+502</option>
                            <option value="+503">+503</option>
                            <option value="+504">+504</option>
                            <option value="+505">+505</option>
                            <option value="+506">+506</option>
                            <option value="+507">+507</option>
                            <option value="+508">+508</option>
                            <option value="+509">+509</option>
                            <option value="+590">+590</option>
                            <option value="+591">+591</option>
                            <option value="+592">+592</option>
                            <option value="+593">+593</option>
                            <option value="+594">+594</option>
                            <option value="+595">+595</option>
                            <option value="+596">+596</option>
                            <option value="+597">+597</option>
                            <option value="+598">+598</option>
                            <option value="+670">+670</option>
                            <option value="+672">+672</option>
                            <option value="+673">+673</option>
                            <option value="+674">+674</option>
                            <option value="+675">+675</option>
                            <option value="+676">+676</option>
                            <option value="+677">+677</option>
                            <option value="+678">+678</option>
                            <option value="+679">+679</option>
                            <option value="+680">+680</option>
                            <option value="+681">+681</option>
                            <option value="+682">+682</option>
                            <option value="+683">+683</option>
                            <option value="+685">+685</option>
                            <option value="+686">+686</option>
                            <option value="+687">+687</option>
                            <option value="+688">+688</option>
                            <option value="+689">+689</option>
                            <option value="+690">+690</option>
                            <option value="+691">+691</option>
                            <option value="+692">+692</option>
                            <option value="+850">+850</option>
                            <option value="+852">+852</option>
                            <option value="+853">+853</option>
                            <option value="+855">+855</option>
                            <option value="+856">+856</option>
                            <option value="+870">+870</option>
                            <option value="+880">+880</option>
                            <option value="+886">+886</option>
                            <option value="+960">+960</option>
                            <option value="+961">+961</option>
                            <option value="+962">+962</option>
                            <option value="+963">+963</option>
                            <option value="+964">+964</option>
                            <option value="+965">+965</option>
                            <option value="+966">+966</option>
                            <option value="+967">+967</option>
                            <option value="+968">+968</option>
                            <option value="+970">+970</option>
                            <option value="+971">+971</option>
                            <option value="+972">+972</option>
                            <option value="+973">+973</option>
                            <option value="+974">+974</option>
                            <option value="+975">+975</option>
                            <option value="+976">+976</option>
                            <option value="+977">+977</option>
                            <option value="+992">+992</option>
                            <option value="+993">+993</option>
                            <option value="+994">+994</option>
                            <option value="+995">+995</option>
                            <option value="+996">+996</option>
                            <option value="+998">+998</option>
                            <option value="+5999">+5999</option>
                            <option value="+1 242">+1 242</option>
                            <option value="+1 246">+1 246</option>
                            <option value="+1 264">+1 264</option>
                            <option value="+1 268">+1 268</option>
                            <option value="+1 284">+1 284</option>
                            <option value="+1 340">+1 340</option>
                            <option value="+1 345">+1 345</option>
                            <option value="+1 441">+1 441</option>
                            <option value="+1 473">+1 473</option>
                            <option value="+1 599">+1 599</option>
                            <option value="+1 649">+1 649</option>
                            <option value="+1 664">+1 664</option>
                            <option value="+1 670">+1 670</option>
                            <option value="+1 671">+1 671</option>
                            <option value="+1 684">+1 684</option>
                            <option value="+1 721">+1 721</option>
                            <option value="+1 758">+1 758</option>
                            <option value="+1 767">+1 767</option>
                            <option value="+1 784">+1 784</option>
                            <option value="+1 809">+1 809</option>
                            <option value="+1 868">+1 868</option>
                            <option value="+1 869">+1 869</option>
                            <option value="+1 876">+1 876</option>
                          </optgroup> -->
                        </select>
                      </div>

                      <div class="col-lg-7 pb-0">
                        <!-- <div class="negro fG">Correo Electrónico</div> -->
                        <input
                          v-model.trim="signupForm.telefono"
                          type="tel"
                          placeholder="TELEFONO"
                          maxlength="10"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-12 pb-3">
                    <!-- <div class="negro fG">Apellido</div> -->
                    <input
                      v-model.trim="signupForm.movil"
                      type="tel"
                      placeholder="MOVIL*"
                      maxlength="10"
                      required
                    />
                  </div>

                  <!-- <div class="col-lg-12 pb-0">

                    <select v-model="signupForm.talla_cubrebocas">
                      <option value="">Talla de cubrebocas</option>
                      <option value="S">S</option>
                      <option value="M">M</option>
                      <option value="L">L</option>
                      <option value="XL">XL</option>
                    </select>
                  </div> -->

                  <div class="col-lg-12 pb-3" v-if="torneo_db == 'SI'">
                    <!-- <div class="negro fG">Apellido</div> -->
                    <span class="negro pl-2">
                      <b>¿Asistirás al torneo? *</b>
                    </span>
                    <br />
                    <label class="pointer">
                      <select
                        v-model="signupForm.torneo"
                        @change="changeTorneo($event)"
                      >
                        <option value=""></option>
                        <option value="SI">SI</option>
                        <option value="NO">NO</option>
                      </select>
                    </label>
                  </div>

                  <div class="col-lg-12 pb-3" v-else-if="clinica_db == 'SI'">
                    <!-- <div class="negro fG">Apellido</div> -->
                    <span class="negro pl-2">
                      <b>¿Asistirás a la Clínica? *</b>
                    </span>
                    <br />
                    <label class="pointer">
                      <select
                        v-model="signupForm.clinica"
                        @change="changeClinica($event)"
                      >
                        <option value=""></option>
                        <option value="SI">SI</option>
                        <option value="NO">NO</option>
                      </select>
                    </label>
                  </div>

                  <div class="col-lg-12 pb-0" v-if="signupForm.torneo == 'SI'">
                    <input
                      v-model.trim="signupForm.handicap"
                      type="text"
                      placeholder="HANDICAP*"
                      required
                    />
                  </div>

                  <div
                    class="col-lg-12 pb-3"
                    v-if="
                      signupForm.torneo == 'SI' &&
                      signupForm.genero == 'Masculino'
                    "
                  >
                    <select v-model="signupForm.talla_tops" required>
                      <option value="">TALLA DE CHAMARRA*</option>
                      <option value="CH">CH</option>
                      <option value="M">M</option>
                      <option value="G">G</option>
                      <option value="EXG">EXG</option>
                      <option value="EXXG">EXXG</option>
                     
                    </select>
                    <!-- <span>
                      *
                      <span @click="toggleOverlay()" class="dorado pointer"
                        >Ver la guía</span
                      >
                      de tallas. Son tallas US y en calzado de golf no existen
                      medios números.
                    </span> -->
                  </div>
                  <div class="col-lg-12 pb-0" v-if="signupForm.clinica == 'SI'">
                    <select v-model="signupForm.talla_guantes" required>
                      <option value="">TALLA DE GUANTE*</option>
                      <option value="S">S</option>
                      <option value="M">M</option>
                      <option value="L">L</option>
                      <option value="XL">XL</option>
                    </select>
                  </div>
                  <div
                    class="col-lg-12 pb-0"
                    v-if="
                      signupForm.torneo == 'SI' &&
                      signupForm.genero == 'Femenino'
                    "
                  >
                    <select v-model="signupForm.talla_tops" required>
                      <option value="">TALLA DE CHAMARRA*</option>
                      <option value="CH">CH</option>
                      <option value="M">M</option>
                      <option value="G">G</option>
                      <option value="EXG">EXG</option>
                      <option value="EXXG">EXXG</option>
                     
                    </select>
                    <!-- <span>
                      *
                      <span @click="toggleOverlay()" class="dorado pointer"
                        >Ver la guía</span
                      >
                      de tallas. Son tallas US y en calzado de golf no existen
                      medios números.
                    </span> -->
                  </div>

                  <div class="col-lg-12 pb-0" v-if="signupForm.clinica == 'SI'">
                    <select v-model="signupForm.horario_clinica" required>
                      <option value="">SELECCIONA UN HORARIO*</option>
                      <option value="10 am">10 am</option>
                      <option value="11 am">11 am</option>
                      <option value="12 pm">12 pm</option>
                    </select>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-12 pb-3">
                    <span class="negro pl-2">
                      <b>¿Asistirás a la comida? *</b>
                    </span>
                    <br />
                    <label class="pointer">
                      <select
                        v-model="signupForm.comida"
                        @change="changeComida($event)"
                      >
                        <option value=""></option>
                        <option value="SI">SI</option>
                        <option value="NO">NO</option>
                      </select>
                    </label>
                  </div>
                </div>

                <div class="row pb-5">
                  <label
                    class="col-12 pointer d-flex justify-content-start align-items-center"
                  >
                    <input
                      type="checkbox"
                      v-model="signupForm.terminos"
                      required
                    />
                    <div class="pl-3 negro">
                      He leído y acepto el
                      <a href="#" target="_blank" rel="noopener noreferrer">
                        aviso de privacidad</a
                      >
                      *
                    </div>
                  </label>
                </div>

                <div class="row pb-5">
                  <div class="col-12 text-center">
                    <button
                      type="submit"
                      class="pointer d-flex align-items-center justify-content-center btnaction fG ml-auto mr-auto"
                    >
                      ENVIAR
                    </button>
                  </div>
                </div>
              </div>
              <!-- <div class="extras text-center">
                    <a @click="toggleForm()" class="pointer"
                      >Regresar al Login</a
                    >
                  </div> -->
            </form>
          </div>

          <div class="col-md-6 pt-md-5 mt-md-5"></div>
        </div>
      </div>
    </section>

    <section class="" id="ubicacion">
      <div class="container bgdorado pt-5 pt-lg-4 px-5 roundedc">
        <div class="row pt-4 d-flex justify-content-center align-items-center">
          <div
            class="col-md-4 text-center fG"
            data-aos="fade-right"
            data-aos-delay="200"
          >
            <img
              class="img-fluid z1 d-block d-md-none pb-5"
              src="../assets/imgs/copaprosa2025/fecha.png"
              alt="Copa Prosa"
            />
            <img
              class="img-fluid z1 d-none d-md-block"
              src="../assets/imgs/copaprosa2025/fecha2.png"
              alt="Copa Prosa"
            />
          </div>

          <div
            class="col-md-3 offset-md-1 text-center text-lg-left pb-5"
            data-aos="fade-right"
            data-aos-delay="200"
          >
            <p class="beige fG">BOSQUE REAL COUNTRY CLUB</p>
            <p class="blanco fM">
              Calle 180 Manzana 001, Bosque Real, 52770 Naucalpan de Juárez, Méx. <br />
            </p>
          </div>

          <div
            class="col-md-4 text-center pb-5 fG"
            data-aos="fade-left"
            data-aos-delay="200"
          >
            <p class="blanco">¿Cómo llegar?</p>
            <div class="iconos">
              <div>
                <a
                  href="https://www.google.com.mx/maps/place/Casa+Club+Bosque+Real,+Calle+180,+Bosque+Real,+52770+Naucalpan+de+Ju%C3%A1rez,+M%C3%A9x./@19.4208944,-99.2877484,17z/data=!4m5!3m4!1s0x85d206a3bad42de3:0x28a58c9e9351cbc3!8m2!3d19.4208944!4d-99.2877484"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    class="img-fluid z1 px-3"
                    src="../assets/imgs/copaprosa2024/google-maps.png"
                    alt="Copa Prosa"
                  />
                </a>
              </div>
              <div>
                <a
                  href="https://ul.waze.com/ul?ll=19.42105583%2C-99.28773880&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    class="img-fluid z1 px-3"
                    src="../assets/imgs/copaprosa2024/waze.png"
                    alt="Copa Prosa"
                  />
                </a>
              </div>
            </div>

            <!-- <p class="text-center blanco small py-2">
              (Se requiere TAG actualizado)
            </p> -->
          </div>
        </div>
      </div>
    </section>

    <section class="py-3" id="agenda">
      <div class="py-5 container-fluid">
        <div class="row pt-2 d-flex justify-content-center align-items-center">
          <div class="col-lg-6">
            <div
              class="col-lg-12 text-center pb-0"
              data-aos="fade-right"
              data-aos-delay="200"
            >
              <img
                class="w-100 z1"
                src="../assets/imgs/copaprosa2025/pelota-golf.png"
                alt="Copa Prosa"
              />
            </div>
          </div>

          <div
            class="col-lg-6 text-left py-5 fG px-5 px-lg-0 bgagenda"
            data-aos="fade-left"
            data-aos-delay="200"
          >
            <div class="row">
              <div class="col-10 offset-2">
                <p>
                  <img
                    class="img-fluid bgblackt"
                    src="../assets/imgs/copaprosa2022/agenda/registro-desayuno.png"
                    alt="Copa Prosa"
                  />

                  Registro |
                  <span class="bold">06:00 hrs a 07:15 hrs</span>
                </p>
                <p>
                  <img
                    class="img-fluid bgblackt"
                    src="../assets/imgs/copaprosa2022/agenda/snackroom.png"
                    alt="Copa Prosa"
                  />

                  Desayuno |
                  <span class="bold">06:00 hrs a 10:00 hrs</span>
                </p>
                <p>
                  <img
                    class="img-fluid bgblackt"
                    src="../assets/imgs/copaprosa2022/agenda/escopetazo.png"
                    alt="Copa Prosa"
                  />

                  Primer escopetazo | <span class="bold">07:15 hrs</span>
                </p>
                <p>
                  <img
                    class="img-fluid bgblackt"
                    src="../assets/imgs/copaprosa2022/agenda/inicio-torneo.png"
                    alt="Copa Prosa"
                  />

                  Inicio del torneo |
                  <span class="bold">07:30 hrs</span>
                </p>
                <p>
                  <img
                    class="img-fluid bgblackt"
                    src="../assets/imgs/copaprosa2022/agenda/clinicas.png"
                    alt="Copa Prosa"
                  />

                  Clínicas | <span class="bold">10:00, 11:00 y 12:00 hrs</span>
                </p>

                <p>
                  <img
                    class="img-fluid bgblackt"
                    src="../assets/imgs/copaprosa2022/agenda/snackroom.png"
                    alt="Copa Prosa"
                  />

                  Taquiza | <span class="bold">10:30 a 13:00 hrs</span>
                </p>

                <p>
                  <img
                    class="img-fluid bgblackt"
                    src="../assets/imgs/copaprosa2022/agenda/fin-de-torneo.png"
                    alt="Copa Prosa"
                  />

                  Fin del torneo | <span class="bold">14:30 hrs</span>
                </p>

                <p>
                  <img
                    class="img-fluid bgblackt"
                    src="../assets/imgs/copaprosa2022/agenda/registro-comida.png"
                    alt="Copa Prosa"
                  />

                  Registro de comida |
                  <span class="bold">14:00 a 15:30 hrs</span>
                </p>

                <p>
                  <img
                    class="img-fluid bgblackt"
                    src="../assets/imgs/copaprosa2022/agenda/snackroom.png"
                    alt="Copa Prosa"
                  />

                  Coctel de bienvenida |
                  <span class="bold">14:00 a 15:00 hrs</span>
                </p>

                <p>
                  <img
                    class="img-fluid bgblackt"
                    src="../assets/imgs/copaprosa2022/agenda/snackroom.png"
                    alt="Copa Prosa"
                  />

                  Comida |
                  <span class="bold">15:30 hrs</span>
                </p>

                

                <p>
                  <img
                    class="img-fluid bgblackt"
                    src="../assets/imgs/copaprosa2022/agenda/comida.png"
                    alt="Copa Prosa"
                  />

                  Premiación |
                  <span class="bold">16:15 hrs</span>
                </p>
                <p>
                  <img
                    class="img-fluid bgblackt"
                    src="../assets/imgs/copaprosa2022/agenda/rifa.png"
                    alt="Copa Prosa"
                  />

                  Rifas | <span class="bold">17:10 hrs</span>
                </p>
                <p>
                  <img
                    class="img-fluid bgblackt"
                    src="../assets/imgs/copaprosa2022/agenda/show.png"
                    alt="Copa Prosa"
                  />

                  Show | <span class="bold">18:30 hrs</span>
                </p>
                <p>
                  <img
                    class="img-fluid bgblackt"
                    src="../assets/imgs/copaprosa2022/agenda/tornafiesta.png"
                    alt="Copa Prosa"
                  />

                  Rifa de auto | <span class="bold">20:30 hrs</span>
                </p>
                <p>
                  <img
                    class="img-fluid bgblackt"
                    src="../assets/imgs/copaprosa2022/agenda/show.png"
                    alt="Copa Prosa"
                  />

                  Show | <span class="bold">21:00 hrs</span>
                </p>

                <!-- <p class="py-4">
              <router-link to="/" class="pointer negro btnaction fG">
                INFORMACIÓN DEL TORNEO
              </router-link>
            </p> -->
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 px-5 mx-5 py-5 text-center">
            <span class="fG beige">IMPORTANTE:</span> <span class="fG negro">Para acceder al Bosque Real es indispensable mostrar tu ID y código QR de acceso al evento</span>
          </div>
        </div>
      </div>
    </section>

    <section id="patrocinadores" class="z1000">
      <div class="container">
        <div
          class="row pb-5 d-flex align-items-center"
          data-aos="fade-up"
          data-aos-delay="500"
        >
          <div class="col-lg-12 text-center fG2 negro pt-2 pb-3">
            <img
              class="img-fluid"
              src="../assets/imgs/copaprosa2025/patrocinadores.jpg"
              alt="Patrocinadores"
            />
          </div>
        </div>
      </div>
    </section>

    <Footer></Footer>

    <div class="overlay" v-if="guia == true">
      <div class="overlaybg" @click="toggleOverlay()"></div>
      <div class="overlay-contenido">
        <div class="container">
          <div class="row">
            <div class="col-12 rounded shadow bg-white py-4 contbtn">
              <div class="btncerrar" @click="toggleOverlay()">
                <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M 7.21875 5.78125 L 5.78125 7.21875 L 14.5625 16 L 5.78125 24.78125 L 7.21875 26.21875 L 16 17.4375 L 24.78125 26.21875 L 26.21875 24.78125 L 17.4375 16 L 26.21875 7.21875 L 24.78125 5.78125 L 16 14.5625 Z"
                  />
                </svg>
              </div>

              <div class="rwow">
                <div class="col-12 text-center">
                  <p class="bold">Guía de tallas US de calzado de golf.</p>
                </div>
              </div>
              <table class="tabletallas">
                <tbody>
                  <tr>
                    <td style="text-align: center"><strong>MX</strong></td>
                    <td style="text-align: center">
                      <strong>US Hombre</strong>
                    </td>
                    <td style="text-align: center">
                      <strong>US Mujer</strong>
                    </td>
                    <td style="text-align: center">
                      <strong>Medida pie</strong>
                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: center">2</td>
                    <td style="text-align: center">4</td>
                    <td style="text-align: center">5</td>
                    <td style="text-align: center">22.1 cm</td>
                  </tr>

                  <tr height="21">
                    <td style="text-align: center">3</td>
                    <td style="text-align: center">5</td>
                    <td style="text-align: center">6</td>
                    <td style="text-align: center">22.9 cm</td>
                  </tr>

                  <tr height="21">
                    <td style="text-align: center">4</td>
                    <td style="text-align: center">6</td>
                    <td style="text-align: center">7</td>
                    <td style="text-align: center">23.8 cm</td>
                  </tr>

                  <tr height="21">
                    <td style="text-align: center">5</td>
                    <td style="text-align: center">7</td>
                    <td style="text-align: center">8</td>
                    <td style="text-align: center">24.6 cm</td>
                  </tr>

                  <tr height="21">
                    <td style="text-align: center">6</td>
                    <td style="text-align: center">8</td>
                    <td style="text-align: center">9</td>
                    <td style="text-align: center">25.5 cm</td>
                  </tr>

                  <tr height="21">
                    <td style="text-align: center">7</td>
                    <td style="text-align: center">9</td>
                    <td style="text-align: center">10</td>
                    <td style="text-align: center">26.3 cm</td>
                  </tr>

                  <tr height="21">
                    <td style="text-align: center">8</td>
                    <td style="text-align: center">10</td>
                    <td style="text-align: center">11</td>
                    <td style="text-align: center">27.1 cm</td>
                  </tr>

                  <tr height="21">
                    <td style="text-align: center">9</td>
                    <td style="text-align: center">11</td>
                    <td style="text-align: center">12</td>
                    <td style="text-align: center">28.0 cm</td>
                  </tr>

                  <tr height="21">
                    <td style="text-align: center">10</td>
                    <td style="text-align: center">12</td>
                    <td style="text-align: center">13</td>
                    <td style="text-align: center">28.8 cm</td>
                  </tr>

                  <tr height="21">
                    <td style="text-align: center">11</td>
                    <td style="text-align: center">13</td>
                    <td style="text-align: center">14</td>
                    <td style="text-align: center">29.7 cm</td>
                  </tr>

                  <tr height="21">
                    <td style="text-align: center">12</td>
                    <td style="text-align: center">14</td>
                    <td style="text-align: center">15</td>
                    <td style="text-align: center">30.5 cm</td>
                  </tr>

                  <tr height="21">
                    <td style="text-align: center">13</td>
                    <td style="text-align: center">15</td>
                    <td style="text-align: center">-</td>
                    <td style="text-align: center">31.4 cm</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SiteNav from "@/components/SiteNav";
import PasswordReset from "@/components/PasswordReset";

import router from "../router/index";

import Footer from "@/components/Footer";
import AOS from "aos";
import swal from "sweetalert2";

import { mapState } from "vuex";

export default {
  components: {
    Footer,
    SiteNav,
  },
  data() {
    return {
      mensaje_reenvio: "",
      torneo_db: false,
      clinica_db: false,
      comida_db: false,
      reenvioForm: {
        codigo: "",
      },
      loginForm: {
        no_cliente: "",
        password: "",
      },
      preForm: {
        codigo: "",
        apellido_paterno: "",
        email: "",
      },
      signupForm: {
        codigo: "",
        nombre_1: "",
        nombre_2: "",
        apellido_paterno: "",
        apellido_materno: "",
        empresa: "",
        puesto: "",
        email_user: "",
        codigo_pais: "",
        telefono: "",
        movil: "",
        comida: "NO",
        torneo: "NO",
        handicap: "",
        talla_tops: "",
        clinica: "NO",
        talla_zapatos: "",
        talla_guantes: "",
        horario_clinica: "",
        talla_cubrebocas: "",
        terminos: false,
        evento: "",
        tipo: "",
        genero: "",
      },
      showLoginForm: true,
      showPasswordReset: false,
      showMonedero: false,
      dateType: "text",
      explotar: true,
      id: null,
      guia: false,
      asistencia: "",
      nombre: "",
    };
  },
  watch: {
    "$route.params.id": function (newId) {
      // Delay the execution to ensure the DOM is fully rendered
      setTimeout(() => {
        if (newId === "agenda") {
          // Scroll to the section with id="agenda"
          const agendaSection = document.getElementById("agenda");
          if (agendaSection) {
            agendaSection.scrollIntoView({ behavior: "smooth" });
          }
        } else if (newId !== undefined) {
          this.traeDatos();
        }
      }, 100);
    },
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: true, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });
    this.id = this.$route.params.id;
    console.log({ id: this.id });

    setTimeout(() => {
      if (this.$route.params.id === "agenda") {
        // Scroll to the section with id="agenda"
        const agendaSection = document.getElementById("agenda");
        if (agendaSection) {
          agendaSection.scrollIntoView({ behavior: "smooth" });
        }
      } else if (this.id != undefined) {
        this.traeDatos();
      }
    }, 100);
  },
  computed: {
    ...mapState(["userProfile"]),
    showNav() {
      //return Object.keys(this.userProfile).length > 1;
      return true;
    },
  },
  methods: {
    updateInputPreform(fieldName, value) {
      // Convert the input value to uppercase and remove accents
      this.preForm[fieldName] = this.removeAccents(value.toUpperCase());
    },
    updateInput(fieldName, value) {
      // Convert the input value to uppercase and remove accents
      this.signupForm[fieldName] = this.removeAccents(value.toUpperCase());
    },
    removeAccents(str) {
      // Mapping of accented characters to their non-accented equivalents
      const accents = {
        á: "a",
        é: "e",
        í: "i",
        ó: "o",
        ú: "u",
        Á: "A",
        É: "E",
        Í: "I",
        Ó: "O",
        Ú: "U",
        ñ: "n",
        Ñ: "N",
      };
      return str.replace(/[áéíóúÁÉÍÓÚñÑ]/g, (match) => accents[match] || match);
    },
    traeDatos() {
      let thes = this;
      console.log("datos iniciales");
      const https = require("https");
      var qData = {
        codigo: this.id,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "datos-iniciales.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.preForm.codigo = res.datos[0].codigo;
              thes.updateInputPreform(
                "apellido_paterno",
                res.datos[0].apellido_paterno
              );
              this.preForm.email = res.datos[0].email;
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    nuevocodigo() {
      this.reenvioForm.codigo = "";
    },
    cambiaFechaType() {
      this.dateType = "date";
      if (this.signupForm.fecha_nacimiento == "")
        this.signupForm.fecha_nacimiento = "1900-01-01";
    },
    toggleForm() {
      this.showLoginForm = !this.showLoginForm;
    },
    togglePasswordReset() {
      this.showPasswordReset = !this.showPasswordReset;
    },
    login(e) {
      this.$store.dispatch("showLoader", true);

      e.preventDefault();

      const https = require("https");
      var qData = {
        no_cliente: this.loginForm.no_cliente,
        email: this.loginForm.email,
        password: this.loginForm.password,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "login2.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              localStorage.setItem(
                "user_copaprosa2021",
                JSON.stringify(res.usuario)
              );

              router.push("/");
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    presignup(e) {
      e.preventDefault();

      console.log({ presignup: this.preForm });

      this.$store.dispatch("showLoader", true);

      let thes = this;
      const https = require("https");
      var qData = this.preForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "presignup.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio presingup");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              //swal.fire("Bien", res.msg, "success");

              console.log(res.datos);
              console.log(res.datos[0].codigo);
              console.log(res.datos[0].email);

              this.asistencia = res.asistencia;
              this.nombre = res.nombre;

              this.signupForm.codigo = res.datos[0].codigo;
              this.signupForm.email_user = res.datos[0].email;

              this.updateInput("nombre_1", res.datos[0].nombre_1.toUpperCase());
              this.updateInput("nombre_2", res.datos[0].nombre_2.toUpperCase());
              this.updateInput(
                "apellido_paterno",
                res.datos[0].apellido_paterno.toUpperCase()
              );
              this.updateInput(
                "apellido_materno",
                res.datos[0].apellido_materno.toUpperCase()
              );
              this.updateInput("empresa", res.datos[0].empresa.toUpperCase());
              this.updateInput("puesto", res.datos[0].puesto.toUpperCase());

              // this.signupForm.telefono = res.datos[0].telefono;
              // this.signupForm.movil = res.datos[0].movil;

              //
              this.signupForm.clinica = res.datos[0].clinica;
              this.signupForm.torneo = res.datos[0].torneo;
              this.signupForm.comida = res.datos[0].comida;
              this.signupForm.tipo = res.datos[0].tipo;

              this.torneo_db = res.datos[0].torneo;
              this.clinica_db = res.datos[0].clinica;
              this.comida_db = res.datos[0].comida;

              if (this.signupForm.torneo == "SI") {
                this.signupForm.evento = "Torneo";
              }
              if (this.signupForm.clinica == "SI") {
                this.signupForm.evento = "Clínica";
              }

              this.preForm = {
                codigo: "",
                apellido_paterno: "",
                email: "",
              };
            } else if (res.status === "reenvio") {
              this.reenvioForm.codigo = res.codigo_reenvio;
              this.mensaje_reenvio = res.msg;
              this.asistencia = res.asistencia;
              this.nombre = res.nombre;

              this.preForm = {
                codigo: "",
                apellido_paterno: "",
                email: "",
              };
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    reenvio() {
      console.log({ reenvio: this.reenvioForm });

      this.$store.dispatch("showLoader", true);

      let thes = this;
      const https = require("https");
      var qData = this.reenvioForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "reenvio.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio reenvio");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    signup(e) {
      e.preventDefault();

      console.log({ registro: this.signupForm });
      this.enviaRegistro();
    },
    async enviaRegistro() {
      this.$store.dispatch("showLoader", true);

      //LLAMAR ENVIO DE CORREO
      let thes = this;
      const https = require("https");
      var qData = this.signupForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "registro.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio registro");
            console.log(response);

            let res = response.body;

            this.asistencia = res.asistencia;

            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");
              this.resetForm();
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    resetForm() {
      this.signupForm = {
        codigo: "",
        nombre_1: "",
        nombre_2: "",
        apellido_paterno: "",
        apellido_materno: "",
        empresa: "",
        puesto: "",
        email_user: "",
        codigo_pais: "",
        telefono: "",
        movil: "",
        torneo: false,
        handicap: "",
        talla_tops: "",
        clinica: false,
        talla_zapatos: "",
        talla_guantes: "",
        horario_clinica: "",
        talla_cubrebocas: "",
        terminos: false,
        evento: "",
      };
    },
    validPass(password) {
      if (password.length < 8) {
        return false;
      }
      return true;
    },
    validPhone(celular) {
      if (celular.length < 10) {
        return false;
      }
      if (isNaN(celular)) {
        return false;
      }

      return true;
    },
    changeEvento(e) {
      if (this.signupForm.evento == "Clínica") {
        this.signupForm.clinica = "SI";
        this.signupForm.torneo = "NO";
      } else if (this.signupForm.evento == "Torneo") {
        this.signupForm.clinica = "NO";
        this.signupForm.torneo = "SI";
      } else if (this.signupForm.evento == "Ninguno") {
        this.signupForm.clinica = "NO";
        this.signupForm.torneo = "NO";
      }
      this.signupForm.talla_zapatos = "";
      this.signupForm.talla_guantes = "";
      this.signupForm.handicap = "";
      this.signupForm.talla_tops = "";
    },
    changeComida(e) {
      // if (this.signupForm.comida == "NO") {
      //   this.signupForm.torneo = "NO";
      //   this.signupForm.clinica = "NO";
      // }
      // this.signupForm.handicap = "";
    },
    changeTorneo(e) {
      if (this.signupForm.torneo === "SI") {
        this.signupForm.clinica = "NO";
        this.signupForm.talla_zapatos = "";
        this.signupForm.talla_guantes = "";
      } else {
        this.signupForm.handicap = "";
        this.signupForm.talla_tops = "";
        this.signupForm.talla_zapatos = "";
      }
    },
    changeClinica(e) {
      if (this.signupForm.clinica === "SI") {
        this.signupForm.torneo = "NO";
        this.signupForm.handicap = "";
        this.signupForm.talla_tops = "";
      } else {
        this.signupForm.talla_zapatos = "";
        this.signupForm.talla_guantes = "";
      }
    },
    toggleOverlay() {
      this.guia = !this.guia;
    },
  },
};
</script>
